<template>
  <!--begin::Mixed Widget 1-->
  <section id="dashboard-analytics">
    <div class="row">
      <!-- Website Analytics Starts-->
      <div class="col-md-12 col-sm-12 col-lg-12">
        <div class="card">
          <div class="card-header d-flex justify-content-between align-items-center">
            <h4 class="card-title">
              {{ $t('dashboard.service_status') }}
            </h4>
          </div>
          <div class="card-body pb-1">
            <div class="d-flex justify-content-around align-items-center flex-wrap">
              <div class="user-analytics mr-2">
                <span class="align-middle text-muted"> {{ $t('dashboard.service_waiting_count') }}</span>
                <div class="d-flex justify-content-center">
                  <div id="radial-success-chart"></div>
                  <h3 class="mt-1 ml-50">{{ waitingServiceCount }}</h3>
                </div>
              </div>
              <div class="sessions-analytics mr-2">
                <span class="align-middle text-muted">
                  {{ $t('dashboard.service_ongoing_count') }}
                </span>
                <div class="d-flex justify-content-center">
                  <div id="radial-warning-chart"></div>
                  <h3 class="mt-1 ml-50">{{ ongoingServiceCount }}</h3>
                </div>
              </div>

              <div class="sessions-analytics mr-2">
                <span class="align-middle text-muted">
                  {{ $t('dashboard.service_completed_count') }}
                </span>
                <div class="d-flex justify-content-center">
                  <div id="radial-warning-chart-2"></div>
                  <h3 class="mt-1 ml-50">{{ completedServiceCount }}</h3>
                </div>
              </div>
              <div class="bounce-rate-analytics">
                <span class="align-middle text-muted">
                  {{ $t('dashboard.service_total_count') }}
                </span>
                <div class="d-flex justify-content-center">
                  <div id="radial-danger-chart"></div>
                  <h3 class="mt-1 ml-50">{{ totalServiceCount }}</h3>
                </div>
              </div>
            </div>
            <div class="my-75" v-if="chartOptions">
              <apexchart height="400" type="bar" :options="chartOptions.options" :series="chartOptions.series"></apexchart>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import moment from "moment";

import baseModule, {
  ERROR,
  SERVICES,
  GET_SERVICES,
  MODULE_NAME,
  SUCCESS,
} from "@/core/services/store/dashboard.module";
import store from "@/core/services/store";

const _MODULE_NAME = MODULE_NAME;

export default {
  name: "DashboardServices",
  components: {
    VueApexCharts
  },
  beforeCreate() {
    function registerStoreModule(moduleName, storeModule) {
      if (!(store && store.state && store.state[moduleName])) {
        store.registerModule(moduleName, storeModule);
      }
    }

    registerStoreModule(_MODULE_NAME, baseModule);
  },
  data() {
    return {};
  },
  computed: {
    error() {
      return store.getters[_MODULE_NAME + "/" + ERROR];
    },
    success() {
      return store.getters[_MODULE_NAME + "/" + SUCCESS];
    },
    services() {
      return store.getters[_MODULE_NAME + "/" + SERVICES];
    },
    waitingServiceCount() {
      let serviceData = this.services;
      if (!serviceData) return 0;


      return _.sumBy(serviceData.counts.filter(item => item.service_status_id === 1), 'service_count');
    },
    ongoingServiceCount() {
      let serviceData = this.services;
      if (!serviceData) return 0;

      return _.sumBy(serviceData.counts.filter(item => !(item.service_status_id === 1 || item.service_status_id === 9)), 'service_count');
    },
    completedServiceCount() {
      let serviceData = this.services;
      if (!serviceData) return 0;

      return _.sumBy(serviceData.counts.filter(item =>  item.service_status_id === 9), 'service_count');
    },
    totalServiceCount() {
      let serviceData = this.services;
      if (!serviceData) return 0;

      return _.sumBy(serviceData.counts, 'service_count');
    },
    chartOptions() {
      let chartData = this.services;
      if (!chartData) return null;

      let self = this;
      let $primary = '#5A8DEE';
      let $gray_light = '#828D99';

      let categories = [];
      let data = [];
      for(let i = 0; i < 15; i++) {
        let dayTime = moment().subtract(i, "day")
        let day = dayTime.format('DD');
        let dayFull =  dayTime.format("DD-MM-YYYY")
        let chartItem = chartData.chartData.find(item => +item.day === +day)

        if (chartItem) {
          categories.push(dayFull);
          data.push(chartItem.service_count);
        }
      }

      return {
        options: {
          chart: {
            height: 260,
            width: '100%',
            type: 'bar',
            toolbar: {
              show: false
            }
          },
          plotOptions: {
            bar: {
              horizontal: false,
              columnWidth: '20%',
              endingShape: 'rounded'
            },
          },
          dataLabels: {
            enabled: false
          },
          colors: [$primary],
          fill: {
            type: 'gradient',
            gradient: {
              shade: 'light',
              type: "vertical",
              inverseColors: true,
              opacityFrom: 1,
              opacityTo: 1,
            },
          },
          xaxis: {
            categories: categories,
            axisBorder: {
              show: false
            },
            axisTicks: {
              show: false
            },
            labels: {
              style: {
                colors: $gray_light
              }
            }
          },
          yaxis: {
            labels: {
              style: {
                color: $gray_light
              },
              formatter: function (val) {
                return val ? +val.toFixed(0) : 0
              }
            },

          },
          legend: {
            show: false
          },
        },
        series: [{
          name: self.$t('dashboard.service_count'),
          data: data
        }],
      }
    }
  },
  mounted() {
    this.filterResults();
  },
  methods: {
    filterResults() {
      this.$store.dispatch(_MODULE_NAME + '/' + GET_SERVICES, {});
    }
  }
};
</script>

